import { z } from "zod";
import apiProductDataSchema from "./apiProductDataSchema";

const apiCoveringDataSchema = apiProductDataSchema.extend({
    coveringType: z.string(),
    isSkirting: z.boolean()
  });

export default apiCoveringDataSchema;